import { Box, Dialog, DialogActions, DialogContent, Grid } from "@mui/material";
import { FC } from "react";
import { useHistory } from "react-router-dom";
import { openRedirectVerticais$ } from "src/App";
import { DEFAULT_PROJETO } from "src/components/projetos/constants";
import { FlatButton } from "src/framework/components/buttons/FlatButton";
import { formState$ } from "src/store/vendas/projetos/store";

interface ModalRedirectVerticaisParams {
    open: boolean;
    onExit: Function;
}

export const ModalRedirectVerticais: FC<ModalRedirectVerticaisParams> = ({ open, onExit }) => {
    const history = useHistory()

    return (
        <Dialog
            open={open}
            maxWidth='md'
        >
            <DialogContent>
                <Grid container spacing={1}>
                    <Grid container size={12}>
                        <Grid size={12}>
                            <Box component={"h2"}>Atenção!</Box>
                            <Box component={"p"} style={{fontSize: "16px"}}>Este projeto já foi encaminhado para pagamento. Alterações não são permitidas neste estágio.</Box>
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <FlatButton
                    color="primary"
                    variant="contained"
                    text="Voltar para a listagem"
                    onClick={()=>{
                        history.replace('/projetos/verticais/engenharia', { done: true })
                        formState$.next(DEFAULT_PROJETO);
                        openRedirectVerticais$.next(false);
                        onExit();
                    }}
                />
            </DialogActions>
        </Dialog>
    )
}

